import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import BackButton from "../../components/backButton/BackButton";
import Spinner from "../../components/spinner/Spinner";
import { consultarAcceso } from "../../registro/registro";
import VentasPanel from "./VentasPanel";
import SolicitudesPanel from "./SolicitudesPanel";
import BitacoraPanel from "./BitacoraPanel";
import ConfiguracionPanel from "./ConfiguracionPanel";
import { Aviso, Panel, PanelContainer, PanelHeader, Tab, Tabs } from "./panelStyles";

// Panel comercial: ventas cargadas en la web, bitácora completa y configuración
// de la alerta de asignación. Solo para usuarios con acceso (lo valida el
// backend en cada pedido; acá además se oculta lo que no corresponde).

// Bitácora y Configuración son solo para IT (el backend también lo valida).
const SECCIONES = [
  { id: "ventas", texto: "Ventas", soloIT: false },
  { id: "solicitudes", texto: "Solicitudes", soloIT: false },
  { id: "bitacora", texto: "Logs", soloIT: true },
  { id: "config", texto: "Configuración", soloIT: true },
];

const PanelComercial = () => {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user.currentUser);
  const token = currentUser?.data?.token || false;

  const [acceso, setAcceso] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [seccion, setSeccion] = useState("ventas");

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }
    let vigente = true;
    consultarAcceso()
      .then((r) => {
        if (vigente) setAcceso(r);
      })
      .finally(() => {
        if (vigente) setCargando(false);
      });
    return () => {
      vigente = false;
    };
  }, [token, navigate]);

  if (cargando) {
    return (
      <PanelContainer>
        <Spinner />
      </PanelContainer>
    );
  }

  if (!acceso?.panel) {
    return (
      <PanelContainer>
        <BackButton />
        <Panel>
          <h1 style={{ fontSize: "1.2rem", color: "var(--violetaOscuro)", margin: 0 }}>
            No tenés acceso al panel comercial
          </h1>
          <Aviso>
            {acceso
              ? "Tu usuario no está habilitado. Pedíselo a alguien que ya tenga acceso al panel."
              : "No se pudo verificar tu acceso. Puede que el panel no esté disponible en este momento."}
          </Aviso>
        </Panel>
      </PanelContainer>
    );
  }

  const esIT = acceso.panel.it === true;
  const visibles = SECCIONES.filter((s) => esIT || !s.soloIT);

  return (
    <PanelContainer>
      <BackButton />
      <PanelHeader>
        <div>
          <h1>Panel comercial</h1>
          <span>Ventas cargadas en la web, registro de actividad y alertas de instalación</span>
        </div>
      </PanelHeader>

      <Tabs>
        {visibles.map((s) => (
          <Tab key={s.id} type="button" $activa={seccion === s.id} onClick={() => setSeccion(s.id)}>
            {s.texto}
          </Tab>
        ))}
      </Tabs>

      {seccion === "ventas" && <VentasPanel esIT={esIT} />}
      {seccion === "solicitudes" && <SolicitudesPanel />}
      {esIT && seccion === "bitacora" && <BitacoraPanel />}
      {esIT && seccion === "config" && <ConfiguracionPanel />}
    </PanelContainer>
  );
};

export default PanelComercial;
